require('persist-js')

const store = new window.Persist.Store('pco-api-documentation')

export default store
